module.exports = __webpack_public_path__ + "img/c06_unitfishingboat_Normal_ua.cafdba66.webp";